import React from "react";
import videojs from "video.js";
import "video.js/dist/video-js.css";

export const VideoJSplayer = ( props ) => {

  const videoRef = React.useRef(null);
  const playerRef = React.useRef(null);
  const {
    options,
    onReady,
    getInfo,
    setTime
  } = props;

  React.useEffect(() => {
    // make sure Video.js player is only initialized once
    if (!playerRef.current) {
      const videoElement = videoRef.current;
      if (!videoElement) return;

      const player = playerRef.current = videojs(videoElement, options, () => {
        console.log("player is ready");
        onReady && onReady(player);
      });
    } else {
      // you can update player here [update player through props]
      const player = playerRef.current;
      player.autoplay(options.autoplay);
      player.src(options.sources);
      // player.currentTime(10)
      player.one('loadedmetadata', function(e) {
        getInfo(player.duration())
      });
    }
  }, [options, videoRef]);

  // Dispose the Video.js player when the functional component unmounts
  React.useEffect(() => {
    const player = playerRef.current;

    return () => {
      if (player) {
        player.dispose();
        playerRef.current = null;
      }
    };
  }, [playerRef]);

  return (
    <div data-vjs-player className="l_video_player">
      <video ref={videoRef} className="l_video_player video-js vjs-big-play-centered" />
    </div>
  );
}




export function VideoJS({video, getInfo, setTime}) {

  const playerRef = React.useRef(null);

  const videoJsOptions = { // lookup the options in the docs for more options

    controls : true,
    preload : 'auto',
    // children:{
      // controlBar: {
      //   children: {
      //     playbackSpeedPopoverMenu: {},
      //     // selectBitrateControlButton: {
      //     //   src:videosrc
      //     // },
      //     verticalVolumeMenuButton: {},
      //     volumeControl: false,
      //     muteToggle:false,
      //     liveDisplay:true,
      //   }
      // }
    // },
    autoplay: true,
    controls: true,
    responsive: true,
    fluid: true,
    sources: [{
      src: video,
      type: 'video/mp4'
    }]
  }

  const handlePlayerReady = (player) => {
    playerRef.current = player;

    // you can handle player events here
    player.on('waiting', () => {
      console.log('player is waiting');
    });

    player.on('dispose', () => {
      console.log('player will dispose');
    });
  };

  // const changePlayerOptions = () => {
  //   // you can update the player through the Video.js player instance
  //   if (!playerRef.current) {
  //     return;
  //   }
  //   // [update player through instance's api]
  //   playerRef.current.src([{src: 'http://ex.com/video.mp4', type: 'video/mp4'}]);
  //   playerRef.current.autoplay(false);
  // };

  return (
    <>

      <VideoJSplayer
        options={videoJsOptions}
        onReady={handlePlayerReady}
        getInfo={getInfo}
        setTime={setTime} />
    </>
  );


}